import { render, staticRenderFns } from "./Plates.vue?vue&type=template&id=46e044e3&scoped=true&"
import script from "./Plates.vue?vue&type=script&lang=js&"
export * from "./Plates.vue?vue&type=script&lang=js&"
import style0 from "./Plates.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Plates.vue?vue&type=style&index=1&id=46e044e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e044e3",
  null
  
)

export default component.exports